/* ──────────────────────────────────────────────────────────────────────────
   The picker's three periods, all rolling back from now (Jay, 2026-10-15:
   Today is the last 24 hours on the viewer's clock, This week the last 7
   days, This month the last 30). Shared so the page and the server agree on
   what each one means.
   ────────────────────────────────────────────────────────────────────────── */

export const PERIODS = [
  { id: "today", label: "Today", hours: 24, versus: "vs the 24 hours before" },
  { id: "week", label: "This week", hours: 7 * 24, versus: "vs the 7 days before" },
  { id: "month", label: "This month", hours: 30 * 24, versus: "vs the 30 days before" },
] as const;

export type PeriodId = (typeof PERIODS)[number]["id"];

export const periodOf = (id: string | undefined) => PERIODS.find((p) => p.id === id) ?? PERIODS[0];

export const SPARK_DAYS = 7;

/** A time zone the server can use, or the fallback when the browser sent nothing usable. */
export function zoneOr(zone: string | undefined, fallback: string): string {
  if (!zone) return fallback;
  try {
    new Intl.DateTimeFormat("en-CA", { timeZone: zone });
    return zone;
  } catch {
    return fallback;
  }
}

/** The last seven calendar days in a time zone, oldest first, ending today. YYYY-MM-DD. */
export function sparkDays(now: Date, timeZone: string): string[] {
  const today = new Intl.DateTimeFormat("en-CA", { timeZone }).format(now);
  const noon = Date.parse(`${today}T12:00:00Z`);
  return Array.from({ length: SPARK_DAYS }, (_, i) => new Date(noon - (SPARK_DAYS - 1 - i) * 86_400_000).toISOString().slice(0, 10));
}
